const TableData = [
  {
    type: "UGC",
    description:
      "Drive user-generated content for your brand (no posts on social media)",
  },
  {
    type: "ShoutOut",
    description:
      "Provide products or services to creators (payments recommended) for tailored posts on social media",
  },
  {
    type: "Giveaway",
    description:
      "Grow your social media following and engagement when creators host giveaways on your behalf",
  },
  {
    type: "Bespoke",
    description:
      'For experiences and campaigns that require more than the typical "product for post" ask of creators',
  },
];
export default TableData;
